export const initialFilters = {
  myRecords: false,
  registeredOnPortal: false,
  periodStart: undefined,
  periodEnd: undefined,
  initialProcessingDate: undefined,
  finalProcessingDate: undefined,
  origin: '',
};

export function filterReducer(state, action) {
  switch (action.type) {
    case 'SET_FILTER':
      return { ...state, [action.payload.key]: action.payload.value };
    case 'RESET_FILTERS':
      return initialFilters;
    default:
      return state;
  }
}
